import 'suggestions-jquery/dist/js/jquery.suggestions.min'

import {
  $BODY,
  $DOCUMENT,
  $WINDOW,
  ACTIVE_CLASS,
  BODY_LOCK_CLASS,
  CLICKED_CLASS,
  DADATA_API_KEY,
  HIDDEN_CLASS,
  L_MOBILE_WIDTH,
  SHOW_CLASS,
  TABLET_WIDTH,
  YA_POPUP_CLASS,
  Z_INDEX_CLASS,
} from '../lib/constants'
import {closeOverlay} from '../blocks/overlay'
import {debounce, isEnterPressed, morph, runFnByWinResize, swipeFunction} from '../lib/utils'
import {resetSelect} from '../components/select'

const $BUY_MAP = $('.js-buy-map')
const $BUY_FORM = $('.js-buy-form')
const $ADDRESS_INPUT = $BUY_FORM.find('#address')
const $SEARCH_BTN = $BUY_FORM.find('.js-buy-form-input-box-search-btn')
const $CHOSEN_CITY = $('.js-set-city')
const $CHOSEN_LATITUDE = $('.js-set-latitude')
const $CHOSEN_LONGITUDE = $('.js-set-longitude')
const $CLEAR_BUTTON = $('.input__erase-btn')
const $FILTER_DROP_BUTTON = $('.filter__erase-btn')

const $OVERLAY = $('.js-overlay:first')
const $OVERLAY_ITEM_YA = $OVERLAY.find('.js-overlay-item-ya')

const $listShell = $('.js-buy-list-shell')
const $listTitle = $listShell.find('.js-buy-list-title')
const $list = $listShell.find('.js-buy-list')
const $pointDict = {}

const $SERVICE_MAP = $('.js-service-map')

export const setMaxHeightForPointDescr = () => {
    const $shell = $('.js-buy-shell')
    const $formShell = $shell.find('.js-buy-form-shell')
    const $formList = $shell.find('.js-buy-list-shell')

    if ($WINDOW.width() > TABLET_WIDTH) {
        $formList.css('max-height', `${$shell.outerHeight() - $formShell.outerHeight()}px`)
    }
}

async function yaMaps(latitude = 55.753995, longitude = 37.614069) {
    await ymaps3.ready

    // Quantize coordinates to fixed precision (4 decimals = ~11m accuracy)
    const precision = 4;

    // Create optimized storage
    const pointMap = new Map();

    function addPoint(lat, lng, domElement) {
        const key = `${Math.round(lat * 10**precision)},${Math.round(lng * 10**precision)}`;
        pointMap.set(key, domElement);
    }

    function getPoint(lat, lng) {
        const key = `${Math.round(lat * 10**precision)},${Math.round(lng * 10**precision)}`;
        return pointMap.get(key);
    }

    const setEvents = (map, marker) => {

        // События клика по 'Показать на карте' в списке
        $list.on('click', '.js-show-point', function () {
            const $parent = $(this).parent()
            const latitude = $parent.data('x')
            const longitude = $parent.data('y')

            $('[data-tab="map"]').click()

            map.update({
                    location:
                        {
                            center: [longitude, latitude], zoom: 15
                        }
                }
            )
        })

        // Событие очистки инпута
        $CLEAR_BUTTON.on('click', function () {
            const inputVal = $($ADDRESS_INPUT).val().trim()

            if (inputVal === '') {
                // Clear fields or reset map
                $CHOSEN_CITY.val('')
                $CHOSEN_LONGITUDE.val('')
                $CHOSEN_LATITUDE.val('')

                // Optionally reset the map or hide results
                map.update(LOCATION)
                marker.update({coordinates: LOCATION.center})

                const params = collectOptionsParams()
                queryPoints(map, params, marker)
            }
        })

        // Событие очистки фильтров
        $FILTER_DROP_BUTTON.on('click', function () {
            resetSelect($('.js-select.buy-form__select'), 'Выберите тип')
            const $hiddenSelect = $BUY_FORM.find('[data-hidden-select]')

            $hiddenSelect.addClass(HIDDEN_CLASS).removeClass(SHOW_CLASS)

            // Clear fields or reset map
            $CHOSEN_CITY.val('')
            $CHOSEN_LONGITUDE.val('')
            $CHOSEN_LATITUDE.val('')
            $($ADDRESS_INPUT).val('')
            map.update(LOCATION)
            marker.update({coordinates: LOCATION.center})

            queryPoints(map, '', marker)
        })

        // Событие изменений формы
        queryPointsFormChange(map, marker)
    }

    const controlFunctions = (map) => {
        function rotateCamera(angle) {
            map.update({
                camera: {
                    azimuth: map.azimuth + angle,
                    tilt: map.tilt,
                    duration: 1000,
                },
            })
        }

        function tiltCamera(angle) {
            map.update({
                camera: {
                    azimuth: map.azimuth,
                    tilt: map.tilt + angle,
                    duration: 1000,
                },
            })
        }

        $('#changeAzimuthLeft').on('click', function () {
            rotateCamera(Math.PI / 4)
        })

        $('#changeAzimuthRight').on('click', function () {
            rotateCamera(-Math.PI / 4)
        })

        $('#upTilt').on('click', function () {
            tiltCamera(-Math.PI / 4)
            $BUY_MAP.removeClass('skew')
        })

        $('#downTilt').on('click', function () {
            tiltCamera(Math.PI / 4)
            $BUY_MAP.addClass('skew')
        })
    }

    const collectOptionsParams = () => {
        let params = []

        const $selects = $BUY_FORM.find('.js-select-native-select')

        $.each($selects, function (_, el) {
            const $el = $(el)
            const $selectedOption = $el.find("[selected='selected']")

            let selectType = $el.attr('name')
            let selectValue = $selectedOption.attr('value')

            if ($selectedOption.length) {
                let paramsOption = `${selectType}=${selectValue}`

                params.push(paramsOption)
            }
            params.push(`city=${$CHOSEN_CITY.val()}`)
            params.push(`latitude=${$CHOSEN_LATITUDE.val()}`)
            params.push(`longitude=${$CHOSEN_LONGITUDE.val()}`)

        })

        return params
    }

    const addCurrentUserGeoMarker = (map) => {
        const renderGeoIcon = () => {
            $('.js-map-geo').html(`
      <svg class="icon icon--32">
                <use xlink:href="/assets/sprite/sprite.svg#geo"></use>
              </svg>
    `)
        }

        const getPointAddressByYmaps = (coordinates) => {
            $.ajax({
                url: `/bitrix/services/main/ajax.php?action=zug:locator.point.getYandexGeo&geocode=${coordinates.toString()}`,
                method: 'post',
                dataType: 'json',
                success: function (result) {
                    if (result) {
                        const point = result.data.response.GeoObjectCollection.featureMember[0]

                        const address = point.GeoObject.metaDataProperty.GeocoderMetaData.text

                        $ADDRESS_INPUT.val(address)
                    }
                },
            })
        }

        const createGeoMarker = (map) => {
            const markerElement = document.createElement('div')
            markerElement.className = 'buy-map__geo js-map-geo'
            markerElement.onclick = () =>
                map.update({
                    location: {
                        ...LOCATION,
                        duration: 400,
                    },
                })

            return new YMapMarker(
                {
                    coordinates: [longitude, latitude],
                    draggable: false,
                    mapFollowsOnDrag: true,
                    onDragEnd: (coordinates) => {
                        marker.update({coordinates: coordinates})
                        // геокодер DADATA - 10000 запросов бесплатно, но только по России,
                        // getPointAddressByDadata(coordinates);

                        //геокодер ymaps - 1000 запросов бесплатно, по всему миру
                        getPointAddressByYmaps(coordinates)
                    },
                },
                markerElement
            )
        }

        const addressInputFunctions = () => {
            $ADDRESS_INPUT
                .suggestions({
                    serviceUrl: 'https://dadata.ru/api/v2',
                    token: DADATA_API_KEY,
                    type: 'ADDRESS',
                    count: 5,
                    onSelect: (suggestion) => {
                        moveToLocation(suggestion)
                    },
                })
                .suggestions()
        }

        const moveToLocation = (suggestion, cityChosen=false) => {
            const geo_lat = suggestion.data.geo_lat
            const geo_lon = suggestion.data.geo_lon
            const city = suggestion.data.city
            if (geo_lat && geo_lon){
                map.update({
                    location: {
                        center: [Number(geo_lon), Number(geo_lat)],
                        duration: 400,
                        zoom: 12
                    },
                })

                $CHOSEN_CITY.val(city)
                $CHOSEN_LONGITUDE.val(geo_lon)
                $CHOSEN_LATITUDE.val(geo_lat)


                const params = collectOptionsParams()
                marker.update({coordinates: [Number(geo_lon), Number(geo_lat)]})
                queryPoints(map, params, marker)
            } else if(!cityChosen) {
                let query = '';
                if (suggestion.value.indexOf('Энгельсс') !== -1){
                    query = 'Энгельск' // В ином случае город определяется по району как Саратов, скрывая основной филиал компании
                } else {
                    query = suggestion.value.substring(0,7)
                }
                suggest(query).then(function(data) {
                    suggestion = {
                        data: data.suggestions[0].data
                    }
                    moveToLocation(suggestion, true)
                })
            }
        }

        const suggest = (query) => {
            const serviceUrl = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
            const request = {
                "query": query,
                "from_bound": { "value": "city" },
                "to_bound": { "value": "city" },
            };
            const params = {
                type: "POST",
                contentType: "application/json",
                headers: {
                    "Authorization": "Token " + DADATA_API_KEY
                },
                data: JSON.stringify(request)
            }

            return $.ajax(serviceUrl, params);
        }


        const marker = createGeoMarker(map)

        map.addChild(marker)

        renderGeoIcon()
        addressInputFunctions(marker, map)

        return marker
    }

    const renderPhoneToList = (phone) => {
        let str = ''

        if (phone) {
            let clearPhoneStr = ''
            let phoneStr = ''
            let clearPhone = []

            if (phone.indexOf('\n') >= 0) {
                clearPhone = phone.replaceAll('\n', ',').split(',')
            } else {
                if (phone.indexOf(',') >= 0) {
                    clearPhone = phone.replaceAll(',', ',').split(',')
                } else {
                    if (phone.indexOf(';') >= 0) {
                        clearPhone = phone.replaceAll(';', ',').split(',')
                    } else {
                        clearPhone.push(phone)
                    }
                }
            }

            $.each(clearPhone, function (_, el) {
                if (el !== '') {
                    clearPhoneStr = '+7' + el.replace(/\D/g, '').slice(1)
                    phoneStr = `${el.trim().replaceAll(' ', '')} `

                    str =
                        str +
                        `<div class="buy__list-item-phone-shell">
                             <button
                               class="buy__list-item-phone-show-btn accessibility-link
                               js-buy-list-item-phone-show-btn">
                               Показать номер
                             </button>
                            
                            <a 
                              class="btn btn--s-size btn--primary""
                              target="_blank"
                              href="tel:${clearPhoneStr}">
                              ${phoneStr}
                            </a>
          </div>`
                }
            })
        }

        return str
    }

    const renderPhoneToListArr = (phone) => {
        let str = ''

        if (phone) {
            let clearPhoneStr = ''
            let phoneStr = ''
            let clearPhone = []

            if (phone.indexOf('\n') >= 0) {
                clearPhone = phone.replaceAll('\n', ',').split(',')
            } else {
                if (phone.indexOf(',') >= 0) {
                    clearPhone = phone.replaceAll(',', ',').split(',')
                } else {
                    if (phone.indexOf(';') >= 0) {
                        clearPhone = phone.replaceAll(';', ',').split(',')
                    } else {
                        clearPhone.push(phone)
                    }
                }
            }

            $.each(clearPhone, function (_, el) {
                if (el !== '') {
                    clearPhoneStr = '+7' + el.replace(/\D/g, '').slice(1)
                    phoneStr = `${el.trim().replaceAll(' ', '')} `

                    str =
                        str +
                        `<a 
                  href="tel:${clearPhoneStr}"
                  class="buy__list-item-address buy__list-item-link buy__list-item-link--block accessibility-link accessibility-link">
                  ${phoneStr}
              </a>`
                }
            })
        }

        return str
    }

    const renderPhone = (phone, className = '') => {
        let str = ''

        if (phone) {
            let clearPhoneStr = ''
            let phoneStr = ''
            let clearPhone = []

            if (phone.indexOf('\n') >= 0) {
                clearPhone = phone.replaceAll('\n', ',').split(',')
            } else {
                if (phone.indexOf(',') >= 0) {
                    clearPhone = phone.replaceAll(',', ',').split(',')
                } else {
                    if (phone.indexOf(';') >= 0) {
                        clearPhone = phone.replaceAll(';', ',').split(',')
                    } else {
                        clearPhone.push(phone)
                    }
                }
            }

            $.each(clearPhone, function (_, el) {
                clearPhoneStr = '+7' + el.replace(/\D/g, '').slice(1)
                phoneStr = `${el.trim().replaceAll(' ', '')} `

                str =
                    str +
                    `<a 
              class="accessibility-link ${className}"
              target="_blank"
              href="tel:${clearPhoneStr}">
              ${phoneStr}
             </a>`
            })
        }

        return str
    }

    const renderSite = (site, className = '', text = '') => {
        if (site && site !== '-' && site) {
            let siteLink = ''
            let siteStr = ''

            siteStr = site
                .replaceAll(`https:\\\\`, '')
                .replaceAll('https://', '')
                .replaceAll('http:\\\\', '')
                .replaceAll('www.', '')
                .replaceAll('/', '')
                .replaceAll(`\\`, '')

            siteLink = site
                .replaceAll(`https:\\\\`, 'https://')
                .replaceAll('http:\\\\', 'https://')
                .replaceAll('www.', 'https://')
                .replaceAll(`\\`, 'https://')

            if (text) {
                return `  <a 
                 target="_blank"
                 href="${siteLink}"
                 class="${className} accessibility-link">
                 ${text}
              </a>
      `
            } else {
                return `  <a 
                 target="_blank"
                 href="${siteLink}"
                 class="${className} accessibility-link">
                 ${siteStr}
              </a>
      `
            }
        } else {
            return ''
        }
    }

    const pointFunctions = (el) => {
        const {ADDRESS, ID, NAME, PHONE, POINT_X, POINT_Y, SITE, TYPE_PRODUCT, TYPE_SERVICE} = el

        const renderSiteRow = (SITE) => {
            if (SITE) {
                return `          
          <div class="buy-map-point__info-row">
              <span class="buy-map-point__info-title">
                Сайт
              </span>
              
             ${renderSite(SITE, 'buy-map-point__info-val')}
            </div>`
            } else return ``
        }

        const renderPhoneRow = (PHONE) => {
            if (PHONE) {
                return `
           <div class="buy-map-point__info-row">
              <span class="buy-map-point__info-title">
                Телефон
              </span>
              
              <div class="buy-map-point__info-val">
                ${renderPhone(PHONE)}
              </div>
            </div>
        `
            } else return ``
        }


        const $point = $(`.js-buy-map-point-${ID}`)

        $point.append(`
          <div class="buy-map-point__popup">
            <div class="buy-map-point__shell js-buy-map-point-shell">
              <button class="buy-map-point__close-btn js-buy-map-point-close-btn">
                  <svg class="icon icon--24">
                    <use xlink:href="/assets/sprite/sprite.svg#cross"></use>
                  </svg>
              </button>

              <h4 class="h4 buy-map-point__name">
                ${NAME}
              </h4>

              <p class="buy-map-point__adress">
                 ${ADDRESS}
              </p>

              <div class="buy-map-point__info-container">
                ${renderSiteRow(SITE)}

                ${renderPhoneRow(PHONE)}
              </div>
            </div>
          </div>
        `)

        const $points = $(`.js-buy-map-point`)
        $point.on('click',  function () {
            const $t = $(this)

            if ($WINDOW.width() > TABLET_WIDTH) {
                $points.removeClass(ACTIVE_CLASS).removeClass(CLICKED_CLASS)
                $points.parent().removeClass(Z_INDEX_CLASS)

                $t.addClass(ACTIVE_CLASS).addClass(CLICKED_CLASS)
                $t.parent().addClass(Z_INDEX_CLASS)
            } else {
                const $clonePopup = $t.find('.js-buy-map-point-shell').clone()

                $BODY.addClass(BODY_LOCK_CLASS)
                $OVERLAY.addClass(SHOW_CLASS).addClass(YA_POPUP_CLASS)
                $OVERLAY_ITEM_YA.html('').append($clonePopup).addClass(SHOW_CLASS)
                closePointPopup()
            }
        })
    }

    /**
     *
     * @param map
     * @param marker
     *
     * События изменений формы
     */
    const queryPointsFormChange = (map, marker) => {
        const queryPointsOptionsPress = () => {
            const $options = $('.js-select-option')

            $options.on('click', function () {
                const params = collectOptionsParams()

                queryPoints(map, params, marker)
            })
        }

        const queryPointsByDeSearchBtnPress = () => {
            $SEARCH_BTN.on('click', function () {
                const params = collectOptionsParams()

                queryPoints(map, params, marker)
            })
        }

        const queryPointsByEnterPress = () => {
            $ADDRESS_INPUT.on('keyup', (event) => {
                if (isEnterPressed(event)) {
                    const params = collectOptionsParams()

                    queryPoints(map, params, marker)
                }
            })
        }

        queryPointsOptionsPress()
        queryPointsByEnterPress()
        queryPointsByDeSearchBtnPress()
    }

    const renderPoint = (el, map) => {
        const {ID, POINT_X, POINT_Y} = el

        let point = getPoint(POINT_X, POINT_Y)
        if (point){
            $(point).show()
        } else {
            point = document.createElement('div')
            point.className = `buy-map__point js-buy-map-point js-buy-map-point-${ID}`

            point.onclick = () => {
                if ($WINDOW.width() > TABLET_WIDTH) {
                    map.update({
                        location: {
                            center: [Number(POINT_Y) + 0.0045, Number(POINT_X) + 0.0012],
                            duration: 500,
                        },
                    })
                }

                if ($WINDOW.width() <= L_MOBILE_WIDTH) {
                    swipeFunction(document.querySelectorAll('.js-overlay'), () => {
                        closeOverlay()
                    })
                }
            }

            const marker = new YMapMarker(
                {
                    coordinates: [POINT_Y, POINT_X],
                    draggable: false,
                },
                point
            )

            map.addChild(marker)

            pointFunctions(el)

            addPoint(POINT_X, POINT_Y, point)
        }


    }

    const closePointPopup = () => {
        $DOCUMENT.on('click', function ({target}) {
            if (
                !$(target).parents('.js-buy-map-point').length &&
                !$(target).hasClass('js-buy-map-point') &&
                $WINDOW.width() >= TABLET_WIDTH
            ) {
                $('.js-buy-map-point').removeClass(ACTIVE_CLASS).removeClass(CLICKED_CLASS)
            }
        })

        $('.js-buy-map-point-close-btn').on('click', function () {
            setTimeout(() => {
                closeOverlay()

                $('.js-buy-map-point').removeClass(ACTIVE_CLASS).removeClass(CLICKED_CLASS)
            }, 100)
        })
    }

    const renderNearListPoint = (points) => {
        let pointStr = ''

        $.each(points, function (_, el) {
            const {NAME, ADDRESS, PHONE, SITE, POINT_X, POINT_Y} = el.elem

            pointStr =
                pointStr +
                `<div 
            data-x="${POINT_X}" data-y="${POINT_Y}"
            class="buy__list-item">
                  <p class="h5 buy__list-item-title">
                   ${NAME}
                  </p>
                  
                  <p class="buy__list-item-address">
                     ${ADDRESS}
                  </p>
                  
                   ${renderSite(SITE, 'buy__list-item-address buy__list-item-link accessibility-link')}
                  
                   ${renderPhoneToListArr(PHONE)}
                   
                   <a class="js-show-point buy__list-item-link accessibility-link" style="cursor: pointer">Показать на карте</a>
                </div>
      `
        })

        return pointStr
    }

    const renderNearList = (points) => {
        const hidePhoneByHideBtn = () => {
            const $hideBtn = $('.js-buy-list-item-phone-show-btn')

            $hideBtn.on('click', function () {
                const $t = $(this)

                $t.hide()
            })
        }

        if (points.length) {
            $listTitle.text(
                `Найдено ${points.length} ${morph(points.length, [
                    'партнер, отвечающий',
                    'партнера, отвечающих',
                    'партнеров, отвечающих',
                ])} выбранным фильтрам`
            )
        } else {

            $listTitle.text(
                `По выбранным фильтрам и адресу не найдено ни одного партнера`
            )
        }

        $list.text('').append(`
            ${renderNearListPoint(points)}
    `)

        hidePhoneByHideBtn()
    }

    const renderPointsToMap = (data, map, marker) => {
        const distanceBetweenPoints = (lat1, lon1, lat2, lon2) => {
            const deg2rad = (deg) => {
                return deg * (Math.PI / 180)
            }

            const R = 6371 // Radius of the earth in km
            const dLat = deg2rad(lat2 - lat1) // deg2rad below
            const dLon = deg2rad(lon2 - lon1)
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

            return R * c
        }

        const sortNearPoints = (data, coordsGeoPoint) => {
            const sortedPointsByDistance = []

            $.each(data, function (i, elem) {
                const {POINT_X, POINT_Y} = elem

                const distance = distanceBetweenPoints(coordsGeoPoint[1], coordsGeoPoint[0], POINT_X, POINT_Y)

                sortedPointsByDistance[i] = {distance, elem}

                renderPoint(elem, map)
            })

            sortedPointsByDistance.sort(function (a, b) {
                return a.distance - b.distance
            })

            renderNearList(sortedPointsByDistance)
            sortedPointsByDistance.length = 5
        }

        const coordsGeoPoint = marker._props.coordinates
        sortNearPoints(data, coordsGeoPoint)
        closePointPopup()
    }

    const queryParams = (params) => {
        let str = ''

        if (params.length) {
            $.each(params, function (_, el) {
                str = str + `&${el}`
            })
        }

        if ($SERVICE_MAP.length) {
            const $baseServiceVal = $('[data-base-value]').attr('data-base-value')
            if (!$baseServiceVal || !$baseServiceVal.length) {
                str = str + '&product=5&service=6'
            } else {
                str = str + `&product=5&service=${$baseServiceVal}`
            }
        }
        return str
    }

    const queryPoints = (map, params, marker) => {
        const url = `/bitrix/services/main/ajax.php?action=zug:locator.point.getlist${queryParams(params)}`

        $.ajax({
            url: url,
            method: 'post',
            dataType: 'json',
            success: function (result) {
                if (result.data) {
                    const {data} = result.data

                    renderPointsToMap(data, map, marker)
                }
            },
        })
    }

    window.map = null

    const LOCATION = {center: [longitude, latitude], zoom: 9}

    const {YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapControls, YMapListener, YMapMarker} = ymaps3
    const {YMapZoomControl} = await ymaps3.import('@yandex/ymaps3-controls@0.0.1')

    ymaps3.ready.then(() => {
        const map = new YMap(document.getElementById('buy-map'), {
            location: LOCATION,
        })

        // Создаем объект карты
        const YMapDefaultScheme = new YMapDefaultSchemeLayer({})
        const YMapDefaultFeatures = new YMapDefaultFeaturesLayer({})
        map.addChild(YMapDefaultScheme)
        map.addChild(YMapDefaultFeatures)
        map.addChild(new YMapControls({position: 'right'}).addChild(new YMapZoomControl({})))

        // Настраиваем контролы
        controlFunctions(map)

        // Устанавливаем маркер клиента по геолокации
        const marker = addCurrentUserGeoMarker(map, YMapListener)

        setEvents(map, marker)
        queryPoints(map, collectOptionsParams(), marker)
    })
}

export const buyFunctions = () => {
    const initYMapWithFetchCoords = () => {
        yaMaps()
    }

    if ($BUY_FORM.length) {
        const toggleShowHiddenSelect = () => {
            const $options = $BUY_FORM.find('[data-toggle-show]')
            const $hiddenSelect = $BUY_FORM.find('[data-hidden-select]')

            $options.on('click', function () {
                const $t = $(this)
                const dataShowAttr = $t.attr('data-toggle-show')

                $hiddenSelect.addClass(HIDDEN_CLASS).removeClass(SHOW_CLASS)

                if (dataShowAttr !== 'hide') {
                    $(`[data-hidden-select=${dataShowAttr}]`).removeClass(HIDDEN_CLASS).addClass(SHOW_CLASS)
                } else {
                    $.each($hiddenSelect, function (_, el) {
                        const $el = $(el)

                        resetSelect($el.find('.js-select'), 'Выберите услугу')
                    })
                }

            })
        }

        toggleShowHiddenSelect()
    }

    if ($BUY_MAP.length && navigator.geolocation && window.ymaps3) {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                const {latitude, longitude} = position.coords

                yaMaps(latitude, longitude)
            },

            function (error) {
                initYMapWithFetchCoords()
            },
            {timeout: 1000, enableHighAccuracy: true}
        )
    }
}
